module.exports = __webpack_public_path__ + "img/1212c_2.fd7d04f4.jpg";